import { TextRun } from 'docx'

const COMMON_OPTIONS = {
  bold: false,
  italic: false,
  underline: false,
  size: 24,
}

class BaseText {
  #text
  #font = 'Century Gothic'
  #options = COMMON_OPTIONS

  constructor(text, options = {}) {
    this.#text = text
    this.#options = { ...COMMON_OPTIONS, ...options }
  }

  get value() {
    return new TextRun({
      text: this.#text,
      font: this.#font,
      size: this.#options.size,
      bold: this.#options.bold,
      italic: this.#options.italic,
      underline: this.#options.underline,
    })
  }
}

export default BaseText
